import React, { useState, useEffect } from 'react'
// import "./offerPrint.css"
import { usePurchaseRoModel } from "../purchaseRoModel";
import { IPrintClumns, YhOfferPrint } from "@/components/OfferPrint/OfferPrint"
import { purchaseRoService } from '../purchaseRoService';
import { IDetailList, IPurchaseRoDetail } from '../purchaseRoType';
import { numberParseChina, formatNum, fmoney, momentFormat } from '@/utils/utils';
import { useDictModel } from '@/views/base/dict/dictModel';
import moment from 'moment';
import useGlobalModel, { getFindItem } from '@/model/globalModel';
export type IMaintenanceAndItemType = {
    total: number
    discount: number
}
export type TotalType = {
    num: number,
    total: number
}
export function PoPrint() {
    const initDesc = { total: 0, discount: 0 }
    const totalDesc = { total: 0, num: 0 }
    const { CustomerData, shopAndOrg: { shopName, shopId, shopCode } } = useGlobalModel()
    const [settlementPartyName, setSettlementPartyName] = useState<string>("")
    const {
        print: { visible, type },
        selectedRow,
        setPrint,
        loadData
    } = usePurchaseRoModel();
    const [formVal, setFormVal] = useState<IPurchaseRoDetail>({});
    const [maintenanceList, setMaintenanceList] = useState<IDetailList[]>([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [itemTotal, setItemTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [total, setTotal] = useState<TotalType>(totalDesc);
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();

    // const { shopAndOrg: { shopCode } } = useGlobalModel()

    useEffect(() => {
        visible && getPoDetailOne()
    }, [visible])
    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await purchaseRoService.one(selectedRow.returnCode as string);
        let { details, ...formVal } = retData;

        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }
        let newTotal = { ...total }

        let newdetails: any = details?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newMaintenanceTotal.discount = item.discountRate as number
            newTotal.num += Number(item.num)
            let { price, discountRate, amount } = item

            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.num) * Number(item.price),
                price: fmoney(price, 2),
                taxPrice: fmoney(formatNum(Number(price) * Number(discountRate) / 100), 2),
                amount: fmoney(amount, 2)
            }
        })

        //这里做最后一行汇总信息展示
        // newdetails?.push({
        //     num: newTotal.num,
        //     No: "",
        //     materialCode: "合计",
        //     amount: fmoney(formVal.totalAmount, 2)
        // })
        if (retData) {
            setMaintenanceList(newdetails as IPurchaseRoDetail[] ?? []);
            setFormVal({ ...formVal, })
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };
    const printNum = async () => {
        await purchaseRoService.printNum(selectedRow.id as string);
        await loadData()
    }
    const onCancel = () => {
        setPrint({ visible: false, type: "1" })
        setMaintenanceList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const columns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '商品编号',
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
        },
        {
            title: '单位',
            dataIndex: 'unitName',
        },
        {
            title: '数量',
            dataIndex: 'num',
        },
        type === "1" ? {
            title: '单价',
            dataIndex: 'price',
        } : null,
        type === "1" ? {
            title: '金额',
            dataIndex: 'amount',
        } : null,
        {
            title: '货位',
            dataIndex: 'shelfCode',
        },
    ]

    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "采购退单号：",
                fieldValue: `${formVal.returnCode}    (${getTreeNodeName(formVal?.status as string)})`,
                className: "w30"
            },
            {
                fieldLabel: "制单日期：",
                fieldValue: momentFormat(formVal?.createTime as string)

            },
            {
                fieldLabel: "",
                fieldValue: "",
                className: "w20"
            },
            {
                fieldLabel: "打印日期：",
                fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm"),
                className: "li-right"
            },
            {
                fieldLabel: "采购单号:",
                fieldValue: maintenanceList?.[0]?.purchaseCode,
                className: "w30"
            },
            {
                fieldLabel: "供应商名称:",
                fieldValue: formVal?.supplierName
            },
            {
                fieldLabel: "",
                fieldValue: "",
                className: "w20"
            },
            {
                fieldLabel: "",
                fieldValue: "",
                className: "w20"
            },

        ],
        footerPeople: [
            {
                fieldLabel: "制表人：",
                fieldValue: formVal?.createUser
            },
            {
                fieldLabel: "库管：",
                fieldValue: ""
            },
            {
                fieldLabel: "出纳：",
                fieldValue: ""
            },
            {
                fieldLabel: "仓库：",
                fieldValue: maintenanceList[0]?.warehouseName
            },
            {
                fieldLabel: "会计：",
                fieldValue: ""
            },
            // {
            //     fieldLabel: "客户：",
            //     fieldValue: formVal?.customerName
            // },

        ],
        note: [{
            fieldLabel: "备注:",
            fieldValue: formVal?.note
        }],
        Total: type === "1" ? {
            numAll: maintenanceList.length,
            receivedAmountChina: numberParseChina(formVal?.payableAmount as number),
            receivedAmount: fmoney(formVal?.payableAmount, 2)
        } : null,

        // Total: [
        //     {
        //         fieldLabel: "大写金额 THE SUM OF：",
        //         fieldValue: numberParseChina(formVal?.receivedAmount as string)
        //     },
        //     {
        //         fieldLabel: "结算类型 Payment Type：",
        //         fieldValue: getTreeNodeName(formVal?.payType as string)
        //     },
        // ],
    }
    const headerTitle = {
        title: `${shopName}退货单`

    }
    return (
        <YhOfferPrint
            title="退货单打印详情"
            type=""
            visible={visible}
            onClose={onCancel}
            columns={columns as IPrintClumns[]}
            printNum={printNum}
            dataSource={maintenanceList.filter(item => item.num !== 0)}
            printShow={printShow}
            headerTitle={headerTitle}
        />
    )
}